// extracted by mini-css-extract-plugin
export default {"p__container":"Questionaires_p__container__E0iOj","p__Info":"Questionaires_p__Info__6pmoH"};